import { render, staticRenderFns } from "./DepartmentsTreeView.vue?vue&type=template&id=52c5b668&"
import script from "./DepartmentsTreeView.vue?vue&type=script&lang=js&"
export * from "./DepartmentsTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports